import { useWizardContext } from '@/app/pages/program_applications/vendor_application/WizardProvider.tsx'
import BasicBusinessInfo from './business_info/BasicBusinessInfo.tsx'
import BusinessAddress from './business_info/BusinessAddress.tsx'
import MailingAddress from './business_info/MailingAddress.tsx'

export default function BusinessInfo() {
  const { currentStep } = useWizardContext()

  if (
    currentStep?.children?.[currentStep?.childPointer].name == 'businessAddress'
  ) {
    return <BusinessAddress />
  } else if (
    currentStep?.children?.[currentStep?.childPointer].name == 'mailingAddress'
  ) {
    return <MailingAddress />
  } else {
    return <BasicBusinessInfo />
  }
}